import users, { employeeUser } from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { peopleManagedByEmployee } from 'modules/employees/store/collections/employeesContractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { peopleLedByEmployee } from 'modules/teams/store/peopleLedByEmployee'

export const filterSelf = (list: number[], employee: Employee): number[] => {
  if (users.current.policy.can('goals.deprecatedCreateForSelf')) {
    return list.concat(employee.attributes.access_id)
  }

  return list
}

export const filterReportees = (
  list: number[],
  employee: Employee,
  contractVersions: ContractVersions
): number[] => {
  if (users.current.policy.can('goals.deprecatedCreateForReportees')) {
    return list.concat(
      peopleManagedByEmployee(employee.id, contractVersions).map(
        (e) => employeeUser(e).attributes.id
      )
    )
  }

  return list
}

export const filterTeam = (
  list: number[],
  employee: Employee,
  contractVersions: ContractVersions
): number[] => {
  if (users.current.policy.can('goals.deprecatedCreateForTeam')) {
    list = list.concat(
      peopleLedByEmployee(teams, memberships, employee.id, contractVersions).map(
        (e) => employeeUser(e).attributes.id
      )
    )
  }

  if (!users.current.policy.can('goals.deprecatedCreateForSelf')) {
    list = list.filter((id) => id !== employee.attributes.access_id)
  }

  return list
}
